import { render, staticRenderFns } from "./product-header-items.vue?vue&type=template&id=19fadde6"
import script from "./product-header-items.vue?vue&type=script&lang=js"
export * from "./product-header-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports